import React, { useEffect, useState } from "react";
import {
  Search,
  DollarSign,
  CheckCircle,
  Loader2,
  Building2,
  Calendar,
  FileText,
  Upload,
  Filter,
} from "lucide-react";
import api from "../../api";
import Menu from "../../components/Menu";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../componentCss/ReportRevenueDistributionItem.css";
import { Form, Button, Table, Row, Col, Card, Badge } from "react-bootstrap";
import formatCurrency from '../../utils/formatCurrency'

const DoctorTransferAdd = () => {
  const navigate = useNavigate();

  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  const now = new Date()
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0)

  const formatDate = (date) => date.toISOString().split("T")[0]

  const [data, setData] = useState([]);
  const [totals, setTotals] = useState({
    total_gross: 0,
    total_cost: 0,
    total_net: 0,
  });

  const [loading, setLoading] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [recibo, setRecibo] = useState(null);
  const [erroData, setErroData] = useState("");
  const [description, setDescription] = useState("");
  const [dataInicio, setDataInicio] = useState(formatDate(firstDay));
  const [dataFim, setDataFim] = useState(formatDate(lastDay));
  const [dataRepasse, setDataRepasse] = useState("");
  const [porcentagemRepasse, setPorcentagemRepasse] = useState('');
  const [totalAmount, setTotalAmount] = useState(0);

  const [filters, setFilters] = useState({
    group_by: "requesting",
    requesting_company: "",
    executing_company: "",
    confirmed: true,
    fund_transfer_requesting_id: "is_null",
    date_from: formatDate(firstDay),
    date_to: formatDate(lastDay), //primeiro e último dia do mês atual
    detail: true,
    pdf: "",
  });

  const [companyOptions, setCompanyOptions] = useState({
    executing: [],
    requesting: [],
  });

  const isSelected = (item) =>
    selectedItems.some(
      (i) =>
        i.cashier_id === item.cashier_id &&
        i.clinic_procedure_id === item.clinic_procedure_id
    );

  const handleSelectItem = (item) => {
    setSelectedItems((prev) => {
      const exists = isSelected(item);
      return exists
        ? prev.filter(
          (i) =>
            !(
              i.cashier_id === item.cashier_id &&
              i.clinic_procedure_id === item.clinic_procedure_id
            )
        )
        : [...prev, item];
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
    } else {
      const allItems = data.flatMap((cashier) =>
        (cashier.items || []).map((item) => ({
          ...item,
          cashier_id: cashier.id,
        }))
      );
      setSelectedItems(allItems);
      setSelectAll(true);
    }
  };

  const validarDatas = () => {
    if (!dataInicio || !dataFim) {
      Swal.fire("Erro", "Informe as datas de início e fim.", "warning");
      return false;
    }
    return true;
  };

  const confirmarSelecao = async () => {
    if (!validarDatas()) return;

    if (selectedItems.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Você precisa selecionar ao menos um item.",
        showConfirmButton: true,
      });
      return;
    }

    if (!description) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Você precisa digitar uma descrição para o repasse.",
        showConfirmButton: true,
      });
      return;
    }

    if (!dataRepasse) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Você precisa selecionar um mês para o repasse.",
        showConfirmButton: true,
      });
      return;
    }

    if (!porcentagemRepasse) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Informe a porcentagem do repasse.",
        showConfirmButton: true,
      });
      return;
    }

    if (!recibo) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Você precisa selecionar um recibo para o repasse.",
        showConfirmButton: true,
      });
      return;
    }

    setCarregando(true);

    try {
      const formData = new FormData();
      formData.append("start_date", dataInicio);
      formData.append("end_date", dataFim);
      formData.append("type", "S");
      formData.append("total_amount", totalAmount || 0);
      const ano = new Date(dataInicio).getFullYear();
      const mesFormatado = String(dataRepasse).padStart(2, "0");
      const mesCompleto = `${ano}-${mesFormatado}`;
      formData.append("transfer_month", mesCompleto);

      formData.append("percentage_transfer", porcentagemRepasse || 0);
      formData.append("description", description.toLocaleUpperCase());
      formData.append("photo", recibo);

      const response = await api.post("api/fund-transfers", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(response.data);

      Swal.fire({
        icon: "success",
        title: "Repasse registrado com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      });
      await api.post("api/cashier/assign-fund-transfer", {
        ids: selectedItems.map((item) => item.clinic_procedure_id),
        type: "req",
        fund_transfer_id: response.data.data.id,
      });
      navigate("/financial/repasse-medico");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao Registrar o Repasse",
        text: "Ocorreu um erro ao registrar o repasse.",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setCarregando(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.post("/api/cashiers/report", filters);

      // res.data.data.forEach((item) => {
      //   item.items.forEach((proc) => {
      //     companiesExec.add(proc.executing_company);
      //     companiesReq.add(proc.requesting_company);
      //   });
      // });

      setData(res.data.data);
      setTotals(res.data.totals);
      setSelectedItems([]);
      setSelectAll(false);

      // Atualizar empresas com base nos novos dados
      const companiesExec = new Set(companyOptions.executing);
      const companiesReq = new Set(companyOptions.requesting);

      res.data.data.forEach((item) => {
        item.items.forEach((proc) => {
          companiesExec.add(proc.executing_company);
          companiesReq.add(proc.requesting_company);
        });
      });

      setCompanyOptions({
        executing: Array.from(companiesExec),
        requesting: Array.from(companiesReq),
      });

    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
      const maxSizeInMB = 2; // Set your max size here
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      // Check file type
      if (!allowedTypes.includes(file.type)) {
        setErroData(
          "Por favor, selecione um arquivo de imagem (jpg, jpeg, png) ou PDF"
        );
        setRecibo(null);
        return;
      }

      // Check file size
      if (file.size > maxSizeInBytes) {
        setErroData(
          `O arquivo é muito grande. Tamanho máximo permitido: ${maxSizeInMB}MB`
        );
        setRecibo(null);
        return;
      }

      setErroData("");
      setRecibo(file);
    }
  };

  // const fetchCompanies = async () => {
  //   try {
  //     const res = await api.post("/api/cashiers/report", {
  //       date_from: filters.date_from,
  //       date_to: filters.date_to,
  //       confirmed: true,
  //       detail: true,
  //     });

  //     const companiesExec = new Set();
  //     const companiesReq = new Set();

  //     console.log('itens', res.data.data)

  //     res.data.data.forEach((item) => {
  //       item.items.forEach((proc) => {
  //         companiesExec.add(proc.executing_company);
  //         companiesReq.add(proc.requesting_company);
  //       });
  //     });

  //     setCompanyOptions({
  //       executing: Array.from(companiesExec),
  //       requesting: Array.from(companiesReq),
  //     });
  //   } catch (err) {
  //     console.error("Erro ao buscar empresas:", err);
  //   }
  // };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCompanyChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      executing_company: field === "executing_company" ? value : "",
      requesting_company: field === "requesting_company" ? value : "",
    }));
  };

  // ------------ Tabela Responsiva ------------
  const TableComponent = () => (
    <div
      className="table-responsive"
      style={{
        overflowY: "auto",
        overflowX: "auto",
        border: "1px solidrgb(245, 50, 16)",
        borderRadius: "0.375rem",
      }}>
      <Table striped hover className="mb-0">
        <thead
          className="table-dark position-sticky"
          style={{ top: 0, zIndex: 10 }}>
          <tr>
            <th style={{ width: "50px" }}>
              <Form.Check
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
                className="text-white"
              />
            </th>
            {/* Paciente: sempre visível */}
            <th style={{ minWidth: "130px" }}>Paciente</th>
            {/* Procedimento: sempre visível */}
            <th style={{ minWidth: "200px" }}>Procedimento</th>
            {/* Solicitante: escondido em xs, visível a partir de sm */}
            <th
              className="d-none d-sm-table-cell"
              style={{ minWidth: "120px" }}>
              Solicitante
            </th>
            {/* Valor Venda: sempre visível */}
            <th
              className="text-end"
              style={{ minWidth: "120px", width: "120px" }}>
              Valor de Venda
            </th>
            {/* Valor Custo: escondido em xs e sm, visível a partir de md */}
            <th
              className="text-end d-none d-md-table-cell"
              style={{ minWidth: "120px", width: "120px" }}>
              Valor de Repasse
            </th>
            {/* Valor Líquido: escondido em xs e sm, visível a partir de md */}
            <th
              className="text-end d-none d-md-table-cell"
              style={{ minWidth: "120px", width: "120px" }}>
              Valor Achemed
            </th>
          </tr>
        </thead>
        <tbody
          style={{
            maxHeight: "calc(100vh - 70px)",
            overflowY: "auto",
            overflowX: "auto",
          }}>
          {data.map((cashier) =>
            cashier.items
              .filter((item) => !item.fund_transfer_requesting_id)
              .map((item, i) => {
                const itemWithCashier = {
                  ...item,
                  cashier_id: cashier.id,
                };
                return (
                  <tr
                    key={`${cashier.id}-${i}`}
                    onClick={() => handleSelectItem(itemWithCashier)}
                    className={`${isSelected(itemWithCashier) ? "table-success" : ""
                      }`}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}>
                    <td style={{ width: "50px" }}>
                      <Form.Check
                        type="checkbox"
                        checked={isSelected(itemWithCashier)}
                        onChange={() => handleSelectItem(itemWithCashier)}
                        onClick={(e) => e.stopPropagation()}
                        size="sm"
                      />
                    </td>
                    <td>
                      <div className="fw-semibold small">
                        {cashier.patient.name}
                      </div>
                    </td>
                    <td>
                      <div
                        className="small text-truncate"
                        title={item.procedure_name}
                        style={{ maxWidth: "200px" }}>
                        {item.procedure_name}
                      </div>
                    </td>
                    <td className="d-none d-sm-table-cell">
                      <Badge bg="primary" className="text-wrap small">
                        {item.requesting_company}
                      </Badge>
                    </td>
                    <td className="text-end fw-bold text-primary small">
                      R$ {parseFloat(item.selling_price).toFixed(2)}
                    </td>
                    <td className="text-end text-warning small d-none d-md-table-cell">
                      R$ {parseFloat(item.cost_price || 0).toFixed(2)}
                    </td>
                    <td className="text-end fw-bold text-success small d-none d-md-table-cell">
                      R$ {parseFloat(item.net_individual || 0).toFixed(2)}
                    </td>
                  </tr>
                );
              })
          )}
        </tbody>
      </Table>
    </div>
  );
  // ------------------------------------------

  const selectedTotals = {
    selling: selectedItems.reduce(
      (sum, item) => sum + Number(item.selling_price),
      0
    ),
    cost: selectedItems.reduce(
      (sum, item) => sum + Number(item.cost_price || 0),
      0
    ),
    net: selectedItems.reduce(
      (sum, item) => sum + Number(item.net_individual || 0),
      0
    ),
  };

  useEffect(() => {
    //console.log("selectedItems:", selectedItems);
    console.log("totals:", selectedTotals);
    setTotalAmount(selectedTotals.selling);
  }, [selectedItems]);

  const ScreenTela = (
    <div>
      <div
        className="container-fluid py-3"
        style={{
          paddingBottom: "120px",
          borderRadius: "10px",
          height: "calc(100vh - 110px)",
          overflowY: "auto",
        }}>
        {/* Header */}
        <div className="mb-2">
          <h4 className="text-dark mb-1 d-flex align-items-center small">
            <DollarSign size={22} className="me-2 text-primary" />
            Relatório de Pagamentos por Médicos
          </h4>
          <p className="text-muted mb-0 very-small">
            Selecione os procedimentos e configure o repasse
          </p>
        </div>

        {/* Filtros */}
        <Card className="shadow-sm border-0 mb-3">
          <Card.Header className="bg-light border-0 py-2">
            <h6 className="mb-0 d-flex align-items-center small">
              <Filter size={16} className="me-2 text-primary" />
              Filtros de Busca
            </h6>
          </Card.Header>
          <Card.Body className="p-2">
            <Row className="g-2">
              {/* Empresa Solicitante ocupa toda largura em xs */}
              <Col xs={12} sm={6} md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small d-flex align-items-center">
                    <Building2 size={14} className="me-1" />
                    Médico Solicitante
                  </Form.Label>
                  <Form.Select
                    value={filters.requesting_company}
                    onChange={(e) =>
                      handleCompanyChange("requesting_company", e.target.value)
                    }
                    size="sm">
                    <option value="">Todas as empresas</option>
                    {companyOptions.requesting.map((name, idx) => (
                      <option key={idx} value={name}>
                        {name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Data Inicial */}
              <Col xs={6} sm={3} md={2}>
                <Form.Group>
                  <Form.Label className="fw-semibold small d-flex align-items-center">
                    <Calendar size={14} className="me-1" />
                    Data Início
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={filters.date_from}
                    onChange={(e) => {
                      setFilters({ ...filters, date_from: e.target.value });
                      setDataInicio(e.target.value);
                    }}
                    size="sm"
                  />
                </Form.Group>
              </Col>

              {/* Data Final */}
              <Col xs={6} sm={3} md={2}>
                <Form.Group>
                  <Form.Label className="fw-semibold small d-flex align-items-center">
                    <Calendar size={14} className="me-1" />
                    Data Fim
                  </Form.Label>
                  <Form.Control
                    type="date"
                    value={filters.date_to}
                    onChange={(e) => {
                      setFilters({ ...filters, date_to: e.target.value });
                      setDataFim(e.target.value);
                    }}
                    size="sm"
                  />
                </Form.Group>
              </Col>

              {/* Botão Buscar ocupa toda largura em xs */}
              <Col xs={12} sm={12} md={4}>
                <Button
                  variant="primary"
                  size="sm"
                  className="w-100 d-flex align-items-center justify-content-center"
                  onClick={fetchData}
                  disabled={loading}>
                  {loading ? (
                    <Loader2 size={14} className="me-1 spin" />
                  ) : (
                    <Search size={14} className="me-1" />
                  )}
                  {loading ? "Buscando..." : "Buscar"}
                </Button>
              </Col>
            </Row>

            {/* Configuração do Repasse (aparece só se houver itens selecionados) */}
            {selectedItems.length > 0 && (
              <>
                <hr className="my-2" />

                <h6 className="fw-semibold mb-2 d-flex flex-column flex-md-row align-items-start align-items-md-center small">
                  <span className="d-flex align-items-center">
                    <FileText size={16} className="me-2" />
                    Configuração do Repasse
                  </span>
                  <Badge
                    bg="light"
                    text="dark"
                    className="ms-md-2 mt-1 mt-md-0">
                    {selectedItems.length} itens
                  </Badge>
                </h6>

                <Row className="g-2">
                  {/* Descrição */}
                  <Col xs={12} md={5} lg={5}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small">
                        Descrição do Repasse
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={2}
                        placeholder="Descrição detalhada..."
                        value={description}
                        maxLength={200}
                        onChange={(e) => setDescription(e.target.value.toUpperCase())}
                        size="sm"
                      />
                      <div className="text-muted small text-end mt-1">
                        {description.length}/200
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Mês do Repasse */}
                  <Col xs={6} md={2} lg={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small">
                        Mês do Repasse
                      </Form.Label>
                      <Form.Select
                        value={dataRepasse}
                        onChange={(e) => setDataRepasse(e.target.value)}
                        size="sm">
                        <option value="">Selecione o mês</option>
                        {meses.map((m, i) => (
                          <option key={i} value={i + 1}>
                            {m}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xs={6} md={2} lg={2}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small">
                        Porcentagem do Repasse (%)
                      </Form.Label>
                      <Form.Control
                        value={porcentagemRepasse}
                        onChange={(e) => setPorcentagemRepasse(e.target.value)}
                        type="number"
                        min={0}
                        max={100}
                        placeholder="0"
                      />
                    </Form.Group>
                  </Col>

                  {/* Recibo/Comprovante */}
                  <Col xs={6} md={3} lg={3}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small d-flex align-items-center">
                        <Upload size={14} className="me-1" />
                        Recibo/Comprovante (Imagem ou PDF)
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={handleFileChange}
                        size="sm"
                        isInvalid={!!erroData}
                      />
                      {erroData && (
                        <Form.Control.Feedback type="invalid" className="small">
                          {erroData}
                        </Form.Control.Feedback>
                      )}
                      {recibo && (
                        <div className="text-success small mt-1">
                          <CheckCircle size={12} className="me-1" />
                          {recibo.name.length > 30
                            ? `${recibo.name.substring(0, 30)}...`
                            : recibo.name}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Card.Body>
        </Card>

        {/* Tabela de Procedimentos */}
        {loading ? (
          <div className="text-center py-5 small">
            <Loader2 size={32} className="spin" />
            <p className="text-muted mt-2">Carregando procedimentos...</p>
          </div>
        ) : data.length > 0 ? (
          <Card
            className="shadow-sm border-0 mb-5"
            style={{
              overflowY: "auto",
              overflowX: "auto",
              border: "1px solid #dee2e6",
              borderRadius: "0.375rem",
              maxHeight: '60vh'
            }}>
            <Card.Header className="bg-light border-0 py-2 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center small">
              <div className="mb-1 mb-md-0">
                <h6 className="mb-0">Procedimentos Disponíveis</h6>
                <small className="text-muted">
                  {
                    data.flatMap((c) =>
                      c.items.filter((i) => !i.fund_transfer_requesting_id)
                    ).length
                  }{" "}
                  encontrados
                </small>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <TableComponent />
            </Card.Body>
          </Card>
        ) : (
          <Card className="shadow-sm border-0 mb-3">
            <Card.Body className="text-center py-5 small">
              <p className="text-muted mb-0">
                Nenhum procedimento encontrado para os filtros selecionados.
              </p>
            </Card.Body>
          </Card>
        )}

        {/* Rodapé Fixo com Totais e Ações */}
        <div
          className="fixed-bottom bg-white border-top shadow-lg"
          style={{
            zIndex: 1020,
            borderTop: "2px solid #dee2e6 !important",
          }}>
          <div className="container-fluid py-2">
            <Row className="align-items-center justify-content-end g-2">
              {/* Totais Gerais */}
              <Col xs={6} md={3}>
                <div className="text-center">
                  <small
                    className="text-muted d-block mb-2"
                  >
                    Total Geral
                  </small>
                  <div
                    className="fw-bold"
                    style={{ lineHeight: "1" }}>
                    <div className="text-primary">
                      Venda: {formatCurrency(totals.total_gross.toFixed(2))}
                    </div>
                    <div className="text-warning my-2">
                      Repasse: {formatCurrency(totals.total_cost.toFixed(2))}
                    </div>
                    {/* <div className="text-success">
                      Achemed: {formatCurrency(totals.total_net.toFixed(2))}
                    </div> */}
                    <div className="text-success">
                      Achemed: {formatCurrency((totals.total_gross - totals.total_cost).toFixed(2))}
                    </div>
                  </div>
                </div>
              </Col>

              {/* Totais Selecionados */}
              <Col xs={6} md={3}>
                <div className="text-center">
                  <small
                    className="text-muted d-block mb-2">
                    Selecionado ({selectedItems.length})
                  </small>
                  <div
                    className="fw-bold"
                    style={{ lineHeight: "1" }}>
                    <div className="text-primary">
                      Venda: {formatCurrency(selectedTotals.selling.toFixed(2))}
                    </div>
                    <div className="text-warning my-2">
                      Repasse: {formatCurrency(selectedTotals.cost.toFixed(2))}
                    </div>
                    <div className="text-success">
                      Achemed: {formatCurrency(selectedTotals.net.toFixed(2))}
                    </div>
                  </div>
                </div>
              </Col>

              {/* Mensagem de Status (oculto em xs) */}
              <Col xs={12} md={2} className="d-none d-md-block">
                <div className="text-center">
                  {selectedItems.length > 0 ? (
                    <div>
                      <Badge bg="success" className="mb-1 small">
                        {selectedItems.length} selecionados
                      </Badge>
                      <div className="small text-muted">
                        Pronto para confirmar
                      </div>
                    </div>
                  ) : (
                    <div className="text-muted small">
                      Nenhum procedimento selecionado
                    </div>
                  )}
                </div>
              </Col>

              {/* Botão Confirmar (sempre visível) */}
              <Col xs={12} md={2}>
                <Button
                  variant="success"
                  size="sm"
                  className="w-100 d-flex align-items-center justify-content-center small"
                  disabled={carregando || selectedItems.length === 0 || erroData.length > 0}
                  onClick={confirmarSelecao}>
                  {carregando ? (
                    <>
                      <Loader2 size={14} className="me-1 spin" />
                      Processando...
                    </>
                  ) : (
                    <>
                      <CheckCircle size={14} className="me-1" />
                      Confirmar
                    </>
                  )}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );

  return <Menu screen={ScreenTela} />;
};

export default DoctorTransferAdd;
